export const setFlow = ( state, flow ) => {
    state.flow = flow
    sessionStorage.setItem('profile-flow', flow)
}

export const setSessionType = ( state, sessionType ) => {
    state.sessionType = sessionType
    sessionStorage.setItem('session-type', sessionType)
}
